import { Color, SkeletonText } from '@billy/design-system'
import { parseISO } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { DATE_FORMAT } from '@features/vatDeclarations/constants/dateFormat'
import { getDaysUntilDeadline } from '@features/vatDeclarations/utils/getDaysUntilDeadline'

import { useLocale } from '../../../../../hooks/useLocale'
import { formatDate } from '../../../../../utils/date-fns'
import * as Styled from './styles'

export interface TaxDeadlineDisplayProps {
  deadlineTimestamp: string
  isLoading?: boolean
}

export const TaxDeadlineDisplay = ({ deadlineTimestamp, isLoading }: TaxDeadlineDisplayProps) => {
  const { t } = useTranslation()
  const { code } = useLocale()

  const daysLeft = getDaysUntilDeadline(deadlineTimestamp)
  const dueDate = formatDate(parseISO(deadlineTimestamp), DATE_FORMAT, code)

  return (
    <Styled.Container>
      <>
        {!isLoading && (
          <Styled.Text colorVariant="secondary" variant="bodySM">
            {t('dashboard.widget.vat.due_date')}
          </Styled.Text>
        )}

        <Styled.TextWrapper>
          {isLoading ? (
            <SkeletonText variant="h1" width={100} />
          ) : (
            <>
              <Styled.Text color={Color.Black} variant="h1">
                {daysLeft}
              </Styled.Text>
              <Styled.Text colorVariant="secondary">{t('day', { count: daysLeft })}</Styled.Text>
            </>
          )}
        </Styled.TextWrapper>

        {isLoading ? (
          <SkeletonText variant="bodySM" />
        ) : (
          <Styled.Text weight="regular" colorVariant="secondary" variant="bodySM">
            {dueDate}
          </Styled.Text>
        )}
      </>
    </Styled.Container>
  )
}
